import React, { useState, useEffect } from "react";

function JarIcon({ size = 1 }: { size?: number }) {
  const w = 120 * size;
  const h = 150 * size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 120 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="35"
        y="2"
        width="50"
        height="6"
        rx="3"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        fill="rgba(249, 115, 22, 0.1)"
      />
      <rect
        x="30"
        y="8"
        width="60"
        height="8"
        rx="3"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        fill="rgba(249, 115, 22, 0.08)"
      />
      <path
        d="M35 16 L35 24"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M85 16 L85 24"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="33"
        y="20"
        width="54"
        height="7"
        rx="2"
        stroke="rgb(249, 115, 22)"
        strokeWidth="1.5"
        fill="rgba(249, 115, 22, 0.12)"
      />
      <ellipse
        cx="33"
        cy="23"
        rx="5"
        ry="4"
        stroke="rgb(249, 115, 22)"
        strokeWidth="1.5"
        fill="rgba(249, 115, 22, 0.08)"
      />
      <ellipse
        cx="87"
        cy="23"
        rx="5"
        ry="4"
        stroke="rgb(249, 115, 22)"
        strokeWidth="1.5"
        fill="rgba(249, 115, 22, 0.08)"
      />
      <path
        d="M35 27 C35 27 20 32 15 40"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M85 27 C85 27 100 32 105 40"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M15 40 C10 50 8 60 8 75 C8 95 15 110 20 118 C28 130 42 138 60 138 C78 138 92 130 100 118 C105 110 112 95 112 75 C112 60 110 50 105 40"
        stroke="rgb(249, 115, 22)"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 50 C20 65 20 80 22 95"
        stroke="rgba(249, 115, 22, 0.25)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <ellipse
        cx="50"
        cy="118"
        rx="14"
        ry="5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.3)"
      />
      <ellipse
        cx="50"
        cy="115"
        rx="14"
        ry="5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.25)"
      />
      <ellipse
        cx="70"
        cy="120"
        rx="12"
        ry="5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.3)"
        transform="rotate(-15 70 120)"
      />
      <ellipse
        cx="70"
        cy="117"
        rx="12"
        ry="5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.25)"
        transform="rotate(-15 70 117)"
      />
      <ellipse
        cx="42"
        cy="110"
        rx="10"
        ry="4"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.3)"
        transform="rotate(10 42 110)"
      />
      <ellipse
        cx="42"
        cy="107"
        rx="10"
        ry="4"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.25)"
        transform="rotate(10 42 107)"
      />
      <ellipse
        cx="60"
        cy="105"
        rx="11"
        ry="4.5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.3)"
        transform="rotate(-5 60 105)"
      />
      <ellipse
        cx="55"
        cy="98"
        rx="9"
        ry="3.5"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.25)"
        transform="rotate(8 55 98)"
      />
      <ellipse
        cx="55"
        cy="0"
        rx="8"
        ry="3"
        stroke="rgb(218, 165, 32)"
        strokeWidth="1.5"
        fill="rgba(255, 215, 0, 0.4)"
        transform="rotate(-20 55 0)"
      />
      <text
        x="48"
        y="120"
        fontSize="7"
        fill="rgb(218, 165, 32)"
        fontWeight="bold"
      >
        $
      </text>
      <text
        x="67"
        y="121"
        fontSize="6"
        fill="rgb(218, 165, 32)"
        fontWeight="bold"
        transform="rotate(-15 67 121)"
      >
        $
      </text>
      <text
        x="57"
        y="107"
        fontSize="6"
        fill="rgb(218, 165, 32)"
        fontWeight="bold"
      >
        $
      </text>
    </svg>
  );
}

const FIRST_VISIT_KEY = "donate_first_visit";
const DISMISSED_KEY = "donate_last_dismissed";
const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

export default function DonateWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [titleHovered, setTitleHovered] = useState(false);

  useEffect(() => {
    const now = Date.now();
    const firstVisit = localStorage.getItem(FIRST_VISIT_KEY);

    if (!firstVisit) {
      localStorage.setItem(FIRST_VISIT_KEY, String(now));
      return;
    }

    const appAgeMs = now - Number(firstVisit);
    if (appAgeMs < ONE_MONTH_MS) return;

    const lastDismissed = localStorage.getItem(DISMISSED_KEY);
    if (!lastDismissed || now - Number(lastDismissed) > ONE_MONTH_MS) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    setIsOpen(false);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      {/* Jar Button */}
      {!isOpen && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "1rem",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <JarIcon size={1.2} />
          <p
            className="donate"
            style={{
              margin: 0,
              marginTop: "0.3rem",
              fontSize: "1.4rem",
              color: "rgb(249, 115, 22)",
              fontWeight: 600,
              textAlign: "center",
              lineHeight: "1.3"
            }}
          >
            На підтримку
            <br />
            проекту
          </p>
        </button>
      )}

      {/* Popup */}
      {isOpen && (
        <>
          <div
            onClick={handleClose}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 91
            }}
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 92,
              pointerEvents: "none"
            }}
          >
            <div
              style={{
                width: "40rem",
                maxWidth: "90vw",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "3rem",
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
                animation: "scaleIn 0.3s ease",
                pointerEvents: "auto",
                position: "relative"
              }}
            >
              <button
                onClick={handleClose}
                style={{
                  position: "absolute",
                  top: "1.5rem",
                  right: "1.5rem",
                  background: "none",
                  border: "none",
                  fontSize: "2rem",
                  color: "#999",
                  cursor: "pointer"
                }}
              >
                ✕
              </button>

              <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                <JarIcon size={1.3} />
              </div>

              <h3
                style={{
                  textAlign: "center",
                  fontSize: "2.4rem",
                  fontWeight: 700,
                  color: "rgb(172, 76, 8)",
                  margin: "0 0 1rem 0"
                }}
              >
                На підтримку проекту
              </h3>

              <p
                style={{
                  textAlign: "center",
                  fontSize: "1.6rem",
                  color: "#666",
                  lineHeight: "1.5",
                  marginBottom: "2rem"
                }}
              >
                Ваша підтримка допомагає нам розвивати Aryn Lyrics та оплачувати
                сервера.
              </p>

              <a
                href="https://send.monobank.ua/jar/4P22uuRvhT"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClose}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "1.4rem",
                  backgroundColor: "rgb(249, 115, 22)",
                  color: "#fff",
                  fontSize: "1.8rem",
                  fontWeight: 600,
                  borderRadius: "10px",
                  textDecoration: "none",
                  textAlign: "center",
                  boxShadow: "0 4px 12px rgba(249, 115, 22, 0.3)"
                }}
              >
                💛 Монобанка
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
